import React, { FC, useMemo } from 'react';
import { isDesktop, isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/common/Button';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { icons } from 'src/configs/icons';
import { useBannerActions } from 'src/hooks/useBannerActions';
import { CmsCta } from 'src/types/cms/cmsFieldTypes';
import { RaffleRuleCmsItem } from '../../types';
import './styles.scss';

type IProps = {
  raffleRules?: RaffleRuleCmsItem[];
};

const RaffleDrawRules: FC<IProps> = ({ raffleRules }) => {
  const { t } = useTranslation();
  const { loginAction, registrAction, categoryAction, depositAction } = useBannerActions();

  const ruleCards = useMemo(() => {
    if (!raffleRules?.length) return [];

    return raffleRules.map((item) => ({
      id: item.value,
      title: item.relation?.title ?? '',
      subtitle: item.relation?.subtitle,
      iconDesktop: item.relation?.iconDesktop?.path,
      iconMobile: item.relation?.iconMobile?.path,
      bonusTicketsCount: item.relation?.bonusTicketsCount ?? 0,
      action: item.relation?.action,
    }));
  }, [raffleRules]);

  const ctaAction = (cta: CmsCta): void => {
    switch (cta?.variant) {
      case 'goToRegister':
        registrAction();
        break;
      case 'goToLogin':
        loginAction();
        break;
      case 'goToCategory':
        categoryAction(cta?.param);
        break;
      case 'goToDeposit':
        depositAction();
        break;
      default:
        return;
    }
  };

  return (
    <div className="raffle_draw_rules_container">
      <div className="raffle_draw_rules_content">
        {ruleCards.map((card, index) => (
          <div key={`${card.id}` + `${index}`} className="raffle_rule_card">
            {isDesktop && card.iconDesktop && (
              <img src={card.iconDesktop} alt={card.iconDesktop} className="raffle_rule_icon" />
            )}
            {isMobile && card.iconMobile && (
              <img src={card.iconMobile} alt={card.iconMobile} className="raffle_rule_icon" />
            )}

            <div className="raffle_rule_content">
              {card.title && <div className="raffle_rule_title" dangerouslySetInnerHTML={{ __html: card.title }} />}
              {card.subtitle && (
                <div className="raffle_rule_subtitle" dangerouslySetInnerHTML={{ __html: card.subtitle }} />
              )}
            </div>
            <div className="raffle_rule_action">
              <p>
                <span>
                  + {card.bonusTicketsCount} {t('ticket')}
                </span>
              </p>
              {card.action?.variant && card.action.variant !== 'noAction' && (
                <Button
                  className="raffle_rule_button secondary-outlined-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    ctaAction(card.action as CmsCta);
                  }}
                >
                  {card.action.label || t('goTo')}
                  <SvgIcon src={icons.arrowRight} />
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RaffleDrawRules;
